/// <reference path="app.ts" />

module Meevo {
    angular.module('meevo.core',
        [
            'ngAnimate',
            'ngAria',
            'ngCookies',
            'ngTouch',
            'ngSanitize',
            'ngResource',
            'ngMaterial',
            'ngMessages',
            'ui.router',
            'ct.ui.router.extras',
            'pascalprecht.translate',
            'angulartics',
            //'angulartics.google.analytics', // Comment back in if we do want to support Google Analytics
            'ng.deviceDetector',
            'ngFileUpload',
            'ngImgCrop',
            'ui.utils.masks',
            'gridster',
            'as.sortable',
            'tmh.dynamicLocale',
            'ngIntlTelInput']);
}